import React from "react";
import { CircularProgress } from "..";
import { OrderItemUI } from "..";
import { getProductTypeName } from "../../utils/Order/Order";
import InfiniteScroll from "react-infinite-scroller";
import { Table } from "reactstrap";
import style from "./styles.module.scss";
import { FormattedDate } from "react-intl";

const OrderList = ({ grid, getOrders, toggle }) => {
  const handleClick = (order) => {
    toggle("order", { order });
  };

  return (
    <div className={`content ${style.grid}`}>
      <InfiniteScroll
        pageStart={0}
        loader={
          <div className="loader" key={0}>
            {grid.loading ? <CircularProgress sm /> : null}
          </div>
        }
        loadMore={getOrders}
        hasMore={grid.hasMore}
      >
        <Table hover>
          <thead>
            <tr>
              <th className="text-center">Type</th>
              <th>Ticker</th>
              <th>Side</th>
              <th className="text-right">Quantity</th>
              <th className="text-right">Price</th>
              <th>Account</th>
              <th>TimeFrame</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {grid.orders == null || grid.orders.length == 0 ? (
              <EmptyTable loading={grid.orders == null} />
            ) : (
              grid.orders.map((order) => (
                <tr key={`order-${order.OrderId}`} onClick={() => handleClick(order)}>
                  <td>
                    <span className="mr-2">#{order.OrderId}</span>
                    <span>{getProductTypeName(order.AssetClassForm)}</span>
                  </td>
                  <td>{OrderItemUI.renderOrderSymbol(order)}</td>
                  <td>{OrderItemUI.renderOrderSide(order)}</td>
                  <td className="text-right">{OrderItemUI.renderOrderQuantity(order)}</td>
                  <td className="text-right">{OrderItemUI.renderOrderPrice(order)}</td>
                  <td>{order.AccountNumber}</td>
                  <td>{OrderItemUI.renderOrderTimeFrame(order)}</td>
                  <td>{OrderItemUI.renderOrderStatus(order)}</td>
                  <td>
                    <FormattedDate value={order.OrderInitDate} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </InfiniteScroll>
    </div>
  );
};

const EmptyTable = ({ loading }) => (
  <tr className={style.empty}>
    <td colSpan="9" style={{ textAlign: "center", padding: "60px" }}>
      {loading ? (
        <CircularProgress style={{ marginTop: "10%" }} />
      ) : (
        <h4 style={{ textAlign: "center" }}>No orders</h4>
      )}
    </td>
  </tr>
);

export default OrderList;
